import { Flex } from "@chakra-ui/react";

export const HorizontalDivider = () => {
  return <Flex height="2px" bgColor="dark" />;
};
